import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { UserService } from '../services/user-service/user.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-toolbar',
    imports: [CommonModule, MatToolbarModule, MatButtonModule, MatIconModule, MatTooltipModule, RouterLink],
    templateUrl: './toolbar.component.html',
    styleUrl: './toolbar.component.sass'
})
export class ToolbarComponent {
  readonly isAuthenticated$: Observable<boolean>;
  readonly isAdmin$: Observable<boolean>;

  constructor(readonly userService: UserService) {
    this.isAuthenticated$ = this.userService.isAuthenticated$;
    this.isAdmin$ = this.userService.isAdmin$;
  }

  logout(): void {
    this.userService.logout().subscribe();
  }
}
